function initElement(element){

     var $element = $(element);
     var maxlength = $element.data('maxlength');
     var options = {
          type: 'character',
          min: 0,
          countSpaces: true,
          countContainerElement: "span",
          countContainerClass: 'count-element-container'
     };
     if (maxlength > 0) {
          options.max = maxlength;
          options.counterText = '%d / '+ maxlength;
     } else {
          options.max = -1;
          options.counterText = '%d';
     }
     $element.wrap($('<div>', {class: 'count-element'}));
     $element.textcounter(options);
}

function init() {
     $('[data-maxlength]').each(function(){
          initElement(this);
     });
}

module.exports = {
    init,
    initElement,
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/maxlength.js